import {
  COLLECTION__ENGAGEMENTS
} from '../services/BE/loopback.api';

export const QUERY__REPORTS__ENGAGEMENTS = {
  collection: COLLECTION__ENGAGEMENTS,
  fields: [
    'id',
    'candidateId',
    'jobId',
    'state',
    'stage',
    'status',
    'introduced',
    'matched',
    'submitted',
    'reviewed',
    'screened',
    'onsite',
    'offered',
    'screen1',
    'screen2',
    'screen3',
    'onsite1',
    'onsite2',
    'rejectionReason',
    'rejectionReasonAdditionalInfo',
    'empFBText',
    'toRecruiterFBText',
    'feedback'
  ],
  order: [
    'state DESC',
    'introduced DESC'
  ],
  include: [
    {
      relation: 'candidate',
      scope: {
        fields: [
          'id',
          'accountId',
          'firstName',
          'lastName',
          'positiveSignals',
          'negativeSignals',
        ],
        include: [
          {
            relation: 'account',
            scope: {
              fields: [
                'firstName',
                'lastName',
              ]
            }
          }
        ]
      }
    },
    {
      relation: 'job',
      scope: {
        fields: [
          'id',
          'jobTitle',
          'employerId'
        ],
        include: [
          {
            relation: 'employer',
            scope: {
              fields: [
                'id',
                'name'
              ]
            }
          }
        ]
      }
    }
  ]
};

export default QUERY__REPORTS__ENGAGEMENTS;
